import { CalendarToday } from '@mui/icons-material';
import { Box, Chip, Grid, Paper, Typography } from '@mui/material';
import InfoCard from 'lib/designSystem/InfoCard';
import React from 'react';

interface ImportantDatesProps {
  quoteDate: string;
  startDate: string;
  endDate: string;
}

const ImportantDates: React.FC<ImportantDatesProps> = ({
  quoteDate,
  startDate,
  endDate,
}) => {
  return (
    <Paper
      sx={{
        p: 1.5,
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          mb: 1.5,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '1rem',
            lineHeight: 1.1,
          }}
        >
          Fechas Importantes
        </Typography>
        <Chip
          label="Cronología"
          size="small"
          color="primary"
          variant="outlined"
          sx={{ height: '18px', fontSize: '0.65rem' }}
        />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <InfoCard
            icon={<CalendarToday />}
            label="Cotización"
            value={quoteDate}
            color="blue"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoCard
            icon={<CalendarToday />}
            label="Inicio"
            value={startDate}
            color="green"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoCard
            icon={<CalendarToday />}
            label="Término"
            value={endDate}
            color="red"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ImportantDates;
